import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import get from 'lodash/get';
import wlConfig from '../../constants/wlConfig';
import classnames from 'classnames';

const {
  theme: {
    styles: {
      inputStyles: {
        textFieldStyles: { label, variant, underline },
      },
    },
  },
} = wlConfig;

const propTypes = {
  InputProps: PropTypes.object,
  InputLabelProps: PropTypes.object,
};

const defaultProps = {
  InputProps: {},
  InputLabelProps: {},
};

const useStyles = makeStyles((theme) => ({
  InputProps_underline: underline,
  InputLabelProps_root: label,
}));

function TenantTextField({ InputProps, InputLabelProps, ...otherProps }) {
  const classes = useStyles();
  return (
    <TextField
      {...otherProps}
      {...(variant && { variant })}
      InputLabelProps={{
        ...InputLabelProps,
        classes: {
          ...get(InputLabelProps, 'classes'),
          root: classnames(
            classes.InputLabelProps_root,
            get(InputLabelProps, 'classes.root')
          ),
        },
      }}
      InputProps={{
        ...InputProps,
        classes: {
          ...get(InputProps, 'classes'),
          underline: classnames(
            classes.InputProps_underline,
            get(InputProps, 'classes.underline')
          ),
        },
      }}
    />
  );
}

TenantTextField.propTypes = propTypes;
TenantTextField.defaultProps = defaultProps;

export default TenantTextField;
